import type { ImovelItemModel } from 'view/reterritorializacao/ImoveisTerritorioTable'
import { validAction } from 'view/reterritorializacao/utils/reterritorializacao'

import type { InativacaoImovelActionModel } from './model-inativacaoImoveis'

export const toImovelItemModel = (imovelDto: InativacaoImovelActionModel): ImovelItemModel => {
  return {
    id: imovelDto.id,
    familias: imovelDto.familias,
    permissaoReterritorializar: imovelDto.permissaoReterritorializar ?? validAction,
  } as ImovelItemModel
}
